import { useEffect, useRef, useState } from 'react'
import { useAuth } from '../auth/AuthContext'
import { Link } from 'react-router-dom'
import './cameraInstaller.css'

const installCommand = "curl -fsSL --proto '=https' https://spectraguardai.com/spectra-camera-install.sh | sh"

export function CameraInstallerAdministration() {
  const { access } = useAuth()
  const command = useRef<HTMLTextAreaElement>(null)
  const [copyState, setCopyState] = useState<'idle' | 'copied' | 'manual'>('idle')

  useEffect(() => {
    if (copyState !== 'copied') return
    const timeout = window.setTimeout(() => setCopyState('idle'), 3000)
    return () => window.clearTimeout(timeout)
  }, [copyState])

  async function copy() {
    try {
      await navigator.clipboard.writeText(installCommand)
      setCopyState('copied')
    } catch {
      command.current?.focus()
      command.current?.select()
      setCopyState('manual')
    }
  }

  if (!access.isGeneralAdministrator) return null

  return <div className="administration-content camera-installer-admin">
    <p><Link to="/central/raspberry">Abrir central Raspberry →</Link></p>
    <section className="camera-installer-card" aria-labelledby="camera-installer-title">
      <div className="camera-installer-heading">
        <span className="camera-installer-icon" aria-hidden="true">&gt;_</span>
        <div><span className="camera-installer-eyebrow">INSTALAÇÃO DE CÂMERAS</span>
          <h2 id="camera-installer-title">Seu assistente em cada Raspberry</h2>
          <p>Mapeie a rede e configure a transmissão das câmeras para a empresa e o cliente escolhidos.</p>
        </div>
      </div>
      <div className="camera-installer-command">
        <div className="camera-installer-command-heading"><label htmlFor="camera-installer-command">Cole no terminal do Raspberry</label>
          <button type="button" onClick={() => void copy()}>{copyState === 'copied' ? '✓ Copiado' : 'Copiar comando'}</button>
        </div>
        <textarea id="camera-installer-command" ref={command} readOnly value={installCommand} rows={3} spellCheck={false} autoCapitalize="off" autoCorrect="off" />
      </div>
      <p className="camera-installer-copy-status" role="status" aria-live="polite">{copyState === 'copied' ? 'Comando copiado. Cole no terminal do Raspberry e pressione Enter.' : copyState === 'manual' ? 'Não foi possível copiar automaticamente. O comando está selecionado; use a opção Copiar do seu dispositivo.' : 'Use o mesmo comando em cada Raspberry que precisar do instalador.'}</p>
      <ol className="camera-installer-steps">
        <li><span aria-hidden="true">1</span><div><strong>Abra o instalador</strong><p>Execute o comando no Raspberry conectado à rede das câmeras. A tela abrirá no navegador dele.</p></div></li>
        <li><span aria-hidden="true">2</span><div><strong>Escolha o destino</strong><p>Entre com sua conta de administrador geral e selecione a empresa e o cliente/local.</p></div></li>
        <li><span aria-hidden="true">3</span><div><strong>Mapeie e revise</strong><p>Informe a faixa de IPs e a senha das câmeras. Teste uma câmera antes de instalar o lote.</p></div></li>
      </ol>
      <div className="camera-installer-notes"><p><strong>Atualização automática:</strong> ao abrir, o instalador busca a versão mais recente. Sem internet, usa a versão já instalada. Uma configuração de câmeras em andamento continua na versão em uso.</p><p><strong>Para outros Raspberry:</strong> é necessário um ambiente gráfico, Python 3, curl e a biblioteca requests. A instalação aproveita o Python da ponte PTZ quando ele já existe.</p><p>Depois, abra pelo menu <strong>Spectra Guard AI — Instalar câmeras</strong>. As senhas são informadas no instalador; o vínculo de cada IP fica salvo no Spectra.</p></div>
    </section>
  </div>
}
